var _a;
import { __decorate, __metadata, __param } from "tslib";
import { AbstractSpaceActionService } from '@/services/space-action-service';
import { I18nService } from '@/services/i18n-service';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
let ShareSpaceActionContribution = class ShareSpaceActionContribution extends AbstractSpaceActionService {
    constructor(_i18nService) {
        super();
        this._i18nService = _i18nService;
    }
    _isShareEnabled(space) {
        return !(space.isPublic || space.isShared) || (space.isShared && space.permission.share);
    }
    registerSpaceActions(spaceActionRegistry) {
        spaceActionRegistry.registerSpaceAction({
            order: 98,
            commandId: 'share-space',
            label: this._i18nService.t('global.btn.share'),
            iconClass: 'SolidShare',
            isEnabled: (space) => {
                return this._isShareEnabled(space);
            },
            isVisible: (space) => {
                return !space.isPublic;
            },
        });
    }
};
ShareSpaceActionContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], ShareSpaceActionContribution);
export { ShareSpaceActionContribution };
